import { c as _c } from "react/compiler-runtime";
export default function DefaultShippingPolicy() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div className="rte"><h2>Shipping Policy Terms</h2></div></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}